export type AdminLayout = {
  showDesktopShell: boolean;
  useWideContentColumns: boolean;
};

const DESKTOP_SHELL_MIN_WIDTH = 1025;
const WIDE_CONTENT_MIN_WIDTH = 1400;

export function resolveAdminLayout(width: number): AdminLayout {
  return {
    showDesktopShell: width >= DESKTOP_SHELL_MIN_WIDTH,
    useWideContentColumns: width >= WIDE_CONTENT_MIN_WIDTH,
  };
}

export function getMobileTableColumnIndexes(columns: readonly string[]) {
  const isCaseBoard = columns[0] === "Case" && columns[1]?.toLowerCase() === "loved one";
  if (isCaseBoard && columns.length >= 8) {
    return [2, 3, 5, 6, 7];
  }

  return columns.map((_, index) => index);
}
